import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterableTransactionsComponent } from './filterable-transactions.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { DropdownModule } from 'src/app/shared/dropdown/dropdown.module';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TransactionPricePipe } from 'src/app/pipes/transaction-price.pipe';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    FilterableTransactionsComponent,
    TransactionPricePipe,
  ],
  imports: [
    CommonModule,
    PreloadSpinnerModule,
    DropdownModule,
    TranslateModule,
    AngularSvgIconModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule,
  ],
  exports: [
    FilterableTransactionsComponent
  ],
  providers: [
    TranslatePipe,
  ],
})
export class FilterableTransactionsModule { }
